"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Crop = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cropModule = _interopRequireDefault(require("./crop.module.scss"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Crop = exports.Crop = /*#__PURE__*/function (_Component) {
  function Crop() {
    var _this;
    _classCallCheck(this, Crop);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Crop, [].concat(args));
    _defineProperty(_this, "state", {
      initialX: 0,
      initialY: 0,
      offsetX: 0,
      offsetY: 0,
      initialWidth: 0,
      initialHeight: 0,
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      containerWidth: "100%",
      containerHeight: "100%",
      containerWidthUpdate: 0,
      containerHeightUpdate: 0,
      activeCrop: false,
      autoCropped: false
    });
    _defineProperty(_this, "crop", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "cropImage", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "cropContainer", /*#__PURE__*/_react["default"].createRef());
    _defineProperty(_this, "activeControl", void 0);
    _defineProperty(_this, "cropOffset", void 0);
    _defineProperty(_this, "document", document);
    _defineProperty(_this, "window", window);
    _defineProperty(_this, "controls", [{
      id: "controlSE",
      className: "controlSe",
      ref: /*#__PURE__*/_react["default"].createRef()
    }, {
      id: "controlNE",
      className: "controlNe",
      ref: /*#__PURE__*/_react["default"].createRef()
    }, {
      id: "controlSW",
      className: "controlSw",
      ref: /*#__PURE__*/_react["default"].createRef()
    }, {
      id: "controlNW",
      className: "controlNw",
      ref: /*#__PURE__*/_react["default"].createRef()
    }]);
    /** set event listeners */
    _defineProperty(_this, "onMouseDownDraw", function (event) {
      if ((event === null || event === void 0 ? void 0 : event.button) !== 0) {
        return;
      }
      event.preventDefault();
      _this.onStartDraw(event);
      _this.document.addEventListener("mousemove", _this.onMouseDraw, {
        passive: false
      });
      _this.document.addEventListener("mouseup", _this.onMouseUp, {
        passive: false
      });
    });
    _defineProperty(_this, "onTouchStartDraw", function (event) {
      event.preventDefault();
      _this.onStartDraw(event.touches[0]);
      _this.document.addEventListener("touchmove", _this.onTouchDraw, {
        passive: false
      });
      _this.document.addEventListener("touchend", _this.onTouchEnd, {
        passive: false
      });
    });
    _defineProperty(_this, "onMouseDownScale", function (event) {
      if ((event === null || event === void 0 ? void 0 : event.button) !== 0) {
        return;
      }
      event.preventDefault();
      _this.onStartScale(event);
      _this.document.addEventListener("mousemove", _this.onScale, {
        passive: false
      });
      _this.document.addEventListener("mouseup", _this.onMouseUp, {
        passive: false
      });
    });
    _defineProperty(_this, "onTouchStartScale", function (event) {
      event.preventDefault();
      _this.onStartScale(event.touches[0]);
      _this.document.addEventListener("touchmove", _this.onScale, {
        passive: false
      });
      _this.document.addEventListener("touchend", _this.onTouchEnd, {
        passive: false
      });
    });
    _defineProperty(_this, "onMouseDownMove", function (event) {
      var _this$crop;
      if ((event === null || event === void 0 ? void 0 : event.button) !== 0 || ((_this$crop = _this.crop) === null || _this$crop === void 0 ? void 0 : _this$crop.current) !== event.target) {
        return;
      }
      event.preventDefault();
      _this.onStartMove(event);
      _this.document.addEventListener("mousemove", _this.onMouseMove, {
        passive: false
      });
      _this.document.addEventListener("mouseup", _this.onMouseUp, {
        passive: false
      });
    });
    _defineProperty(_this, "onTouchStartMove", function (event) {
      var _this$crop2;
      if (((_this$crop2 = _this.crop) === null || _this$crop2 === void 0 ? void 0 : _this$crop2.current) !== event.touches[0].target) {
        return;
      }
      event.preventDefault();
      _this.onStartMove(event.touches[0]);
      _this.document.addEventListener("touchmove", _this.onTouchMove, {
        passive: false
      });
      _this.document.addEventListener("touchend", _this.onTouchEnd, {
        passive: false
      });
    });
    _defineProperty(_this, "onMouseUp", function (event) {
      event.preventDefault();
      _this.onEnd();
      _this.document.removeEventListener("mousemove", _this.onMouseDraw);
      _this.document.removeEventListener("mousemove", _this.onScale);
      _this.document.removeEventListener("mousemove", _this.onMouseMove);
      _this.document.removeEventListener("mouseup", _this.onMouseUp);
    });
    _defineProperty(_this, "onTouchEnd", function (event) {
      event.preventDefault();
      _this.onEnd();
      _this.document.removeEventListener("touchmove", _this.onTouchDraw);
      _this.document.removeEventListener("touchmove", _this.onScale);
      _this.document.removeEventListener("touchmove", _this.onTouchMove);
      _this.document.removeEventListener("touchend", _this.onTouchEnd);
    });
    _defineProperty(_this, "onMouseDraw", function (e) {
      _this.onDraw(e);
      e.preventDefault();
    });
    _defineProperty(_this, "onTouchDraw", function (e) {
      e.preventDefault();
      _this.onDraw(e.touches[0]);
    });
    _defineProperty(_this, "onMouseMove", function (e) {
      e.preventDefault();
      _this.onMove(e);
    });
    _defineProperty(_this, "onTouchMove", function (e) {
      e.preventDefault();
      _this.onMove(e.touches[0]);
    });
    _defineProperty(_this, "getContainerOffset", function () {
      var _this$cropImage;
      var imageBox = (_this$cropImage = _this.cropImage) === null || _this$cropImage === void 0 ? void 0 : _this$cropImage.current.getBoundingClientRect();
      var top = imageBox.top,
        left = imageBox.left,
        width = imageBox.width,
        height = imageBox.height;
      _this.setState({
        containerWidth: width,
        containerHeight: height
      });
      _this.setCropOffset({
        top: top + window.scrollY,
        left: left + window.scrollX
      });
    });
    _defineProperty(_this, "onStartDraw", function (e) {
      //update container
      _this.getContainerOffset();
      _this.setState({
        activeCrop: true,
        initialX: _this.setOffset(e.pageX, "left"),
        initialY: _this.setOffset(e.pageY, "top"),
        x: _this.setOffset(e.pageX, "left"),
        y: _this.setOffset(e.pageY, "top"),
        width: 0,
        height: 0
      });
      _this.document.addEventListener("mousedown", _this.handleOutsideClick, {
        passive: false
      });
    });
    _defineProperty(_this, "onDraw", function (e) {
      var _this$state = _this.state,
        initialX = _this$state.initialX,
        initialY = _this$state.initialY;
      var x = initialX;
      var y = initialY;
      var width = _this.setOffset(e.pageX, "left") - initialX;
      var height = _this.setOffset(e.pageY, "top") - initialY;
      if (width < 0) {
        x += width;
        width = width * -1;
      }
      if (height < 0) {
        y += height;
        height = height * -1;
      }
      _this.setState(_this.maxCropSize(width, height, x, y));
    });
    _defineProperty(_this, "onStartScale", function (e) {
      var _this$state2 = _this.state,
        x = _this$state2.x,
        y = _this$state2.y;
      _this.activeControl = e.target.id;
      _this.setState({
        initialX: x,
        initialY: y
      });
    });
    _defineProperty(_this, "onScale", function (e) {
      var _this$state3 = _this.state,
        x = _this$state3.x,
        y = _this$state3.y,
        initialX = _this$state3.initialX,
        initialY = _this$state3.initialY,
        initialWidth = _this$state3.initialWidth,
        initialHeight = _this$state3.initialHeight;
      var clientX = (e.touches ? e.touches[0].clientX : e.clientX) + window.scrollX;
      var clientY = (e.touches ? e.touches[0].clientY : e.clientY) + window.scrollY;
      var offsetX = initialX - _this.setOffset(clientX, "left");
      var offsetY = initialY - _this.setOffset(clientY, "top");

      //X min
      switch (_this.activeControl) {
        case "controlNW":
        case "controlSW":
          /* istanbul ignore else */
          if (Math.trunc(initialWidth + offsetX) < _this.props.min) {
            offsetX = _this.props.min - initialWidth;
          }
          break;
        case "controlSE":
        case "controlNE":
          /* istanbul ignore else */
          if (Math.trunc(offsetX * -1) < _this.props.min) {
            initialX = _this.setOffset(clientX, "left") - _this.props.min;
          }
          break;
        default:
          break;
      }

      //Y min
      switch (_this.activeControl) {
        case "controlNW":
        case "controlNE":
          /* istanbul ignore else */
          if (Math.trunc(initialHeight + offsetY) < _this.props.min) {
            offsetY = _this.props.min - initialHeight;
          }
          break;
        case "controlSW":
        case "controlSE":
          /* istanbul ignore else */
          if (Math.trunc(offsetY * -1) < _this.props.min) {
            initialY = _this.setOffset(clientY, "top") - _this.props.min;
          }
          break;
        default:
          break;
      }

      //max crop size
      var _this$getCropDimensio = _this.getCropDimensions(Math.trunc(_this.setOffset(clientX, "left") - initialX), Math.trunc(_this.setOffset(clientY, "top") - initialY)),
        width = _this$getCropDimensio.width,
        height = _this$getCropDimensio.height;
      if (_this.state.initialY - offsetY < 0) {
        offsetY = _this.state.initialY;
      }
      if (_this.state.initialX - offsetX < 0) {
        offsetX = _this.state.initialX;
      }

      //switch based on control used
      switch (_this.activeControl) {
        case "controlNE":
          height = Math.trunc(initialHeight + offsetY);
          y = _this.state.initialY - offsetY;
          break;
        case "controlNW":
          height = Math.trunc(initialHeight + offsetY);
          width = Math.trunc(initialWidth + offsetX);
          y = _this.state.initialY - offsetY;
          x = _this.state.initialX - offsetX;
          break;
        case "controlSW":
          width = Math.trunc(initialWidth + offsetX);
          x = _this.state.initialX - offsetX;
          break;
        default:
          break;
      }
      _this.setState({
        x: x,
        y: y,
        width: width,
        height: height
      });
    });
    _defineProperty(_this, "onStartMove", function (e) {
      _this.setState({
        initialX: _this.setOffset(e.pageX, "left"),
        initialY: _this.setOffset(e.pageY, "top"),
        offsetX: _this.state.x,
        offsetY: _this.state.y
      });
    });
    _defineProperty(_this, "onMove", function (e) {
      var _this$crop3, _this$cropImage2;
      var _this$state4 = _this.state,
        initialX = _this$state4.initialX,
        initialY = _this$state4.initialY,
        width = _this$state4.width,
        height = _this$state4.height;
      var x = _this.state.offsetX + (_this.setOffset(e.pageX, "left") - initialX);
      var y = _this.state.offsetY + (_this.setOffset(e.pageY, "top") - initialY);

      //max crop size
      var cropBox = (_this$crop3 = _this.crop) === null || _this$crop3 === void 0 || (_this$crop3 = _this$crop3.current) === null || _this$crop3 === void 0 ? void 0 : _this$crop3.getBoundingClientRect();
      var imageBox = (_this$cropImage2 = _this.cropImage) === null || _this$cropImage2 === void 0 || (_this$cropImage2 = _this$cropImage2.current) === null || _this$cropImage2 === void 0 ? void 0 : _this$cropImage2.getBoundingClientRect();
      if (cropBox && imageBox) {
        if (x + width > imageBox.width) {
          x = imageBox.width - cropBox.width;
        }
        if (y + height > imageBox.height) {
          y = imageBox.height - cropBox.height;
        }
        if (x < 0) {
          x = 0;
        }
        if (y < 0) {
          y = 0;
        }
        _this.setState({
          x: x,
          y: y
        });
      }
    });
    _defineProperty(_this, "onEnd", function () {
      var _this$state5 = _this.state,
        width = _this$state5.width,
        height = _this$state5.height;
      if (_this.state.width < _this.props.min || _this.state.height < _this.props.min) {
        _this.setState({
          activeCrop: false
        });
      }
      _this.returnCropValues();
      _this.setState({
        initialWidth: width,
        initialHeight: height
      });
    });
    _defineProperty(_this, "handleOutsideClick", function (e) {
      if (!_this.handle || _this.handle.contains(e.target)) {
        return;
      }
      _this.document.removeEventListener("mousedown", _this.handleOutsideClick);
    });
    return _this;
  }
  _inherits(Crop, _Component);
  return _createClass(Crop, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.window.addEventListener("resize", this.getContainerOffset, {
        passive: false
      });
      this.crop.current.addEventListener("mousedown", this.onMouseDownMove, {
        passive: false
      });
      this.crop.current.addEventListener("touchstart", this.onTouchStartMove, {
        passive: false
      });
      this.cropImage.current.addEventListener("mousedown", this.onMouseDownDraw, {
        passive: false
      });
      this.cropImage.current.addEventListener("touchstart", this.onTouchStartDraw, {
        passive: false
      });
      this.controls.forEach(function (control) {
        control.ref.current.addEventListener("mousedown", _this2.onMouseDownScale, {
          passive: false
        });
        control.ref.current.addEventListener("touchstart", _this2.onTouchStartScale, {
          passive: false
        });
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this;
      this.window.removeEventListener("resize", this.getContainerOffset);
      this.crop.current.removeEventListener("mousedown", this.onMouseDownMove);
      this.crop.current.removeEventListener("touchstart", this.onTouchStartMove);
      this.cropImage.current.removeEventListener("mousedown", this.onMouseDownDraw);
      this.cropImage.current.removeEventListener("touchstart", this.onTouchStartDraw);
      this.controls.forEach(function (control) {
        control.ref.current.removeEventListener("mousedown", _this3.onMouseDownScale);
        control.ref.current.removeEventListener("touchstart", _this3.onTouchStartScale);
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this.autoCrop();
      this.setRotate(prevProps);
    }
  }, {
    key: "setOffset",
    value: /**	setters */

    function setOffset(value, direction) {
      return value - this.cropOffset[direction];
    }
  }, {
    key: "setCropOffset",
    value: function setCropOffset(cropOffset) {
      this.cropOffset = cropOffset;
    }
  }, {
    key: "isNinetyDegreeRotation",
    value: function isNinetyDegreeRotation() {
      return [90, 270].indexOf(this.props.rotate) >= 0;
    }
  }, {
    key: "setRatioValue",
    value: function setRatioValue(value) {
      var original = this.isNinetyDegreeRotation() ? this.props.originalSize.height : this.props.originalSize.width;
      var ratio = this.state.containerWidth / original;
      return value * ratio;
    }
  }, {
    key: "shouldAutoCrop",
    value: function shouldAutoCrop() {
      var _this$props$autoCrop, _this$props$autoCrop2;
      return ((_this$props$autoCrop = this.props.autoCrop) === null || _this$props$autoCrop === void 0 ? void 0 : _this$props$autoCrop.autoCrop) && ((_this$props$autoCrop2 = this.props.autoCrop) === null || _this$props$autoCrop2 === void 0 ? void 0 : _this$props$autoCrop2.width) > 0 && this.state.containerWidth !== "100%" && !this.state.autoCropped;
    }
  }, {
    key: "shouldResetToAutoCrop",
    value: function shouldResetToAutoCrop() {
      var _this$props$autoCrop3, _this$props$autoCrop4;
      return ((_this$props$autoCrop3 = this.props.autoCrop) === null || _this$props$autoCrop3 === void 0 ? void 0 : _this$props$autoCrop3.autoCrop) && ((_this$props$autoCrop4 = this.props.autoCrop) === null || _this$props$autoCrop4 === void 0 ? void 0 : _this$props$autoCrop4.width) > 0;
    }
  }, {
    key: "autoCrop",
    value: function autoCrop() {
      if (this.shouldAutoCrop()) {
        //update container
        this.getContainerOffset();
        this.setAutoCropState();
      }
    }
  }, {
    key: "setAutoCropState",
    value: function setAutoCropState() {
      var stateUpdate;

      //initial size and position
      if (this.isNinetyDegreeRotation()) {
        stateUpdate = {
          x: this.setRatioValue(this.props.autoCrop.y),
          y: this.setRatioValue(this.props.autoCrop.x),
          width: this.setRatioValue(this.props.autoCrop.height),
          height: this.setRatioValue(this.props.autoCrop.width),
          activeCrop: true,
          autoCropped: true
        };
      } else {
        stateUpdate = {
          x: this.setRatioValue(this.props.autoCrop.x),
          y: this.setRatioValue(this.props.autoCrop.y),
          width: this.setRatioValue(this.props.autoCrop.width),
          height: this.setRatioValue(this.props.autoCrop.height),
          activeCrop: true,
          autoCropped: true
        };
      }

      //rotation updates
      switch (this.props.rotate) {
        case 90:
          // x: container width - current x - crop width
          stateUpdate.x = this.state.containerWidth - stateUpdate.x - stateUpdate.width - 2;
          break;
        case 180:
          // x: container width - current x - crop width
          stateUpdate.x = this.state.containerWidth - stateUpdate.x - stateUpdate.width - 2;

          //y container height - current y - crop height
          stateUpdate.y = this.state.containerHeight - stateUpdate.y - stateUpdate.height - 2;
          break;
        case 270:
          //y container height - current y - crop height
          stateUpdate.y = this.state.containerHeight - stateUpdate.y - stateUpdate.height - 2;
          break;
      }
      this.setState(stateUpdate, this.onEnd);
    }
  }, {
    key: "getRotatedContainerDimensions",
    value: function getRotatedContainerDimensions(rotate, imageBox) {
      if (rotate % 180 === 0) {
        return {
          containerWidthUpdate: 0,
          containerHeightUpdate: 0
        };
      } else {
        return {
          containerWidthUpdate: imageBox.width - this.state.containerWidth,
          containerHeightUpdate: imageBox.height - this.state.containerHeight
        };
      }
    }
  }, {
    key: "getRotatedDimensions",
    value: function getRotatedDimensions(stateUpdate) {
      stateUpdate.width = this.state.height;
      stateUpdate.height = this.state.width;
      stateUpdate.initialWidth = this.state.initialHeight;
      stateUpdate.initialHeight = this.state.initialWidth;
      return stateUpdate;
    }
  }, {
    key: "getRotatedPosition",
    value: function getRotatedPosition(stateUpdate, direction, imageBox) {
      if (direction === "right") {
        stateUpdate.y = this.state.x;
        stateUpdate.x = imageBox.width - (this.state.y + this.state.height + 2);
      } else {
        stateUpdate.x = this.state.y;
        stateUpdate.y = imageBox.height - (this.state.x + this.state.width + 2);
      }
      return stateUpdate;
    }
  }, {
    key: "setRotate",
    value: function setRotate(prevProps) {
      var rotate = this.props.rotate;
      if (rotate !== prevProps.rotate) {
        var _this$cropImage3;
        var direction;
        var rotateChange = rotate - prevProps.rotate;

        //get rotate direction
        switch (rotateChange) {
          case 90:
          case -270:
            direction = "right";
            break;
          default:
            direction = "left";
            break;
        }
        var imageBox = (_this$cropImage3 = this.cropImage) === null || _this$cropImage3 === void 0 ? void 0 : _this$cropImage3.current.getBoundingClientRect();
        var stateUpdate = this.getRotatedContainerDimensions(rotate, imageBox);

        //update crop if active
        if (this.state.activeCrop) {
          stateUpdate = this.getRotatedDimensions(stateUpdate);
          stateUpdate = this.getRotatedPosition(stateUpdate, direction, imageBox);
        }

        //update values, then return
        this.setState(stateUpdate, this.returnCropValues);

        //update container
        this.getContainerOffset();
      }
    }
  }, {
    key: "getCropDimensions",
    value: function getCropDimensions() {
      var _this$crop4, _this$cropImage4;
      var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var height = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var cropBox = (_this$crop4 = this.crop) === null || _this$crop4 === void 0 || (_this$crop4 = _this$crop4.current) === null || _this$crop4 === void 0 ? void 0 : _this$crop4.getBoundingClientRect();
      var imageBox = (_this$cropImage4 = this.cropImage) === null || _this$cropImage4 === void 0 || (_this$cropImage4 = _this$cropImage4.current) === null || _this$cropImage4 === void 0 ? void 0 : _this$cropImage4.getBoundingClientRect();
      if (cropBox && imageBox) {
        if (cropBox.left - imageBox.left + width > imageBox.width) {
          width = imageBox.width - cropBox.left - 2 + imageBox.left;
        }
        if (cropBox.top - imageBox.top + height > imageBox.height) {
          height = imageBox.height - cropBox.top - 2 + imageBox.top;
        }
      }
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "maxCropSize",
    value: function maxCropSize(initialWidth, initialHeight, x, y) {
      var _this$state6 = this.state,
        initialX = _this$state6.initialX,
        initialY = _this$state6.initialY;

      //max crop size
      var _this$getCropDimensio2 = this.getCropDimensions(initialWidth, initialHeight),
        width = _this$getCropDimensio2.width,
        height = _this$getCropDimensio2.height;
      if (x < 0) {
        x = 0;
        width = initialX;
      }
      if (y < 0) {
        y = 0;
        height = initialY;
      }
      return {
        width: width,
        height: height,
        x: x,
        y: y
      };
    }
  }, {
    key: "returnCropValues",
    value: function returnCropValues() {
      var originalSize = this.props.originalSize;
      var _this$state7 = this.state,
        x = _this$state7.x,
        y = _this$state7.y,
        width = _this$state7.width,
        height = _this$state7.height,
        containerWidth = _this$state7.containerWidth;

      //calculate actual image to preview ratio
      var ratio = originalSize.width / containerWidth;
      var values = {
        x: Math.floor(x * ratio),
        y: Math.floor(y * ratio),
        width: Math.ceil(width * ratio),
        height: Math.ceil(height * ratio)
      };
      this.props.cropCallback && this.props.cropCallback(values);
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.shouldResetToAutoCrop()) {
        this.setAutoCropState();
      } else {
        this.setState({
          activeCrop: false
        });
      }
    }
  }, {
    key: "getControlClass",
    value: function getControlClass() {
      return this.state.activeCrop ? _cropModule["default"].control : _cropModule["default"].handle;
    }
  }, {
    key: "getMaxSize",
    value: function getMaxSize() {
      return this.props.maxImageSize || "auto";
    }
  }, {
    key: "renderControls",
    value: function renderControls() {
      return this.controls.map(function (control) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          ref: control.ref,
          key: control.id,
          id: control.id,
          className: _cropModule["default"][control.className]
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-testid": "crop",
        className: _cropModule["default"].cropContainer,
        ref: this.cropContainer,
        style: {
          width: this.state.containerWidth,
          height: this.state.containerHeight
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _cropModule["default"].crop
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: this.getControlClass(),
        "data-testid": "cropControl",
        style: {
          left: this.state.x,
          top: this.state.y,
          width: this.state.width,
          height: this.state.height,
          touchAction: "none"
        },
        ref: this.crop
      }, this.renderControls()), /*#__PURE__*/_react["default"].createElement("img", {
        src: this.props.src,
        alt: "crop source",
        ref: this.cropImage,
        style: {
          transform: "rotate(".concat(this.props.rotate, "deg)"),
          top: this.state.containerHeightUpdate / 2,
          left: this.state.containerWidthUpdate / 2,
          maxHeight: this.getMaxSize(),
          maxWidth: this.getMaxSize()
        },
        onLoad: this.getContainerOffset
      })));
    }
  }]);
}(_react.Component);
Crop.propTypes = {
  cropCallback: _propTypes["default"].func,
  activeCallback: _propTypes["default"].func,
  src: _propTypes["default"].string.isRequired,
  autoCrop: _propTypes["default"].object,
  originalSize: _propTypes["default"].object,
  min: _propTypes["default"].number,
  rotate: _propTypes["default"].number,
  maxImageSize: _propTypes["default"].number
};
Crop.defaultProps = {
  autoCrop: {},
  originalSize: {},
  min: 10,
  rotate: 0,
  maxImageSize: null
};
var _default = exports["default"] = Crop;